// js/sections/LoginSection.js
class LoginSection extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    // Check URL hash for recover password
    this._checkUrlHash();
  }
  
  _checkUrlHash() {
    if (window.location.hash === '#recover-password' || window.location.hash === '#recover') {
      // Find the recover tab button and trigger it
      const cosTabs = document.querySelector('cos-tabs');
      if (!cosTabs) return;
      cosTabs.changeTab(1);
    }
  }
};
if (!window.customElements.get("cos-login")) window.customElements.define("cos-login", LoginSection);
